module.exports = __webpack_public_path__ + "img/yaoqing.f791bd31.svg";